"use client";

import { c as _c } from "react/compiler-runtime";
import { type FC, type PropsWithChildren, useEffect } from "react";
import { clsx } from "clsx";
import { useIsMounted } from "~/client/hooks";
import { useDataFilter } from "~/client/services";
import { bem as _bem } from "~/shared/styles";
const bem = _bem("transition");
const Transition: FC<PropsWithChildren> = t0 => {
  const $ = _c(8);
  const {
    children
  } = t0;
  const isMounted = useIsMounted();
  const [, setDataFilter] = useDataFilter();
  let t1;
  let t2;
  if ($[0] !== setDataFilter) {
    t1 = () => () => setDataFilter(_temp);
    t2 = [setDataFilter];
    $[0] = setDataFilter;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== isMounted) {
    t3 = clsx(bem(), isMounted && bem(undefined, "mounted"));
    $[3] = isMounted;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children || $[6] !== t3) {
    t4 = <div className={t3}>{children}</div>;
    $[5] = children;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default Transition;
function _temp(f) {
  return {
    date: f.date
  };
}